<template>
  <div class="Dashbord">
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom" v-for="item in items" :key="item.id">
          <!-- <div :class="'WineTypes__Header WineTypes__Header--' + item.name" v-if='item.wineLabel.length > 0'> -->
          <h2>
            <span>
              {{ item.name }}
            </span>
            <!-- <a href="#" class="more_info">više informacija</a> -->
            <router-link
              :to="{
                name: 'wine_type',
                params: {
                  id: item.id,
                  name_wine_type: item.name,
                  color_wine_type: item.description,
                },
              }"
              class="moreInfo"
              >Više informacija
              <i class="fa fa-chevron-right"></i>
            </router-link>
          </h2>
          <!-- </div> -->
          <div class="WineTypes__Content">
            <template v-if="item.wineLabel.length < visak">
              <div
                class="WineTypes__Content__Wine"
                v-for="item1 in item.wineLabel"
                :key="item1.id"
              >
                <div class="WineBox">
                  <div class="WineBox__Img">
                    <img v-bind:id="'slika_' + item1.id"
                    v-bind:src="nadjiSlikuLok(item1.id)"
                    @error="(e) => {e.target.src = '../assets/iconsWine/wineImg.png?sig=' + new Date()}"
                      alt="Boca Vina"
                    />
                  </div>
                  <!-- /.WineBox__Img -->
                  <div class="WineBox__Title">
                    <!-- {{ item1.name }} -->
                    <router-link
                      :to="{
                        name: 'wine_year',
                        params: {
                          id: item1.id,
                          name_wine_type: item1.wineType.name,
                          id_wine_type: item1.wineType.id
                        },
                      }"
                    >
                      <p v-if="item1.name.length <= 23">
                        {{ item1.name }}
                      </p>
                      <p v-else :title="item1.name">
                        {{ item1.name.substring(0, 20) }}...
                      </p>
                    </router-link>
                  </div>
                  <!-- /.title -->
                </div>
                <!-- /.WineBox -->

                <div class="WineYears">
                  <template v-if="item1.wine !== null">
                    <template v-if="item1.wine.length < 7">
                      <span v-for="item2 in item1.wine" :key="item2.id">
                        <a
                        v-on:click="routerLinkToDetails(item1, item2.id)"
                        class="columnRightVineType"
                        >
                          {{ item2.year }}
                      </a>
                      </span>
                    </template>
                    <template v-else>
                      <span
                        v-for="item2 in item1.wine.slice(0, 6)"
                        :key="item2.id"
                      >
                        <a
                        v-on:click="routerLinkToDetails(item1, item2.id)"
                        class="columnRightVineType"
                        >
                          {{ item2.year }}
                    </a>
                      </span>
                    </template>
                  </template>
                </div>
              </div>
              <!-- /.WineTypes__Content__Wine -->
            </template>
            <template v-else>
              <div
                class="WineTypes__Content__Wine"
                v-for="item1 in item.wineLabel.slice(0, visak)"
                :key="item1.id"
              >
                <div class="WineBox">
                  <div class="WineBox__Img">
                    <img v-bind:id="'slika_' + item1.id"
                    v-bind:src="nadjiSlikuLok(item1.id)"
                    @error="(e) => {e.target.src = '../assets/iconsWine/wineImg.png?sig=' + new Date()}"
                      alt="Boca Vina"
                    />
                  </div>
                  <!-- /.WineBox__Img -->
                  <div class="WineBox__Title">
                    <!-- {{ item1.name }} -->
                    <router-link
                      :to="{
                        name: 'wine_year',
                        params: {
                          id: item1.id,
                          name_wine_type: item1.wineType.name,
                          id_wine_type: item1.wineType.id
                        },
                      }"
                    >
                      {{ item1.name }}
                    </router-link>
                  </div>
                  <!-- /.title -->
                </div>
                <!-- /.WineBox -->

                <div class="WineYears">
                  <template v-if="item1.wine !== null">
                    <template v-if="item1.wine.length < 7">
                      <span v-for="item2 in item1.wine" :key="item2.id">
                        <a
                        v-on:click="routerLinkToDetails(item1, item2.id)"
                          
                          class="columnRightVineType"
                        >
                        {{item2.year}}
                      </a>
                      </span>
                    </template>
                    <template v-else>
                      <span
                        v-for="item2 in item1.wine.slice(0, 6)"
                        :key="item2.id"
                      >
                        <a
                        v-on:click="routerLinkToDetails(item1, item2.id)"
                           class="columnRightVineType"
                        >
                        {{item2.year}}
                    </a>
                      </span>
                    </template>
                  </template>
                </div>
              </div>
              <!-- /.WineTypes__Content__Wine -->
            </template>
          </div>
          <!-- /.WineTypes__Content -->
        </section>
        <!-- /.WineTypes -->
      </v-container>
    </div>
    <!-- /.Actions__Content -->
  </div>
  <!-- /.Dashboard -->
</template>

<script>
import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";

import { nadjiSliku } from "../helpers/Functions";

export default {
  name: "WineTypes",
  dialog: false,
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      items: [],
      window: {
        width: 0,
      },
      visak: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    routerLinkToDetails(item, lokID) {
      this.$router.push({
        name: 'single_wine',
        params: { id: lokID, slika: document.getElementById("slika_" + item.id).src},
      });
    },
    nadjiSlikuLok(id){
      let returnImageUrl ="";

      returnImageUrl = nadjiSliku(id);

      return returnImageUrl;
    },
    handleResize() {
      this.window.width = window.innerWidth;

      // alert(this.window.width);

      this.visak = Math.floor((this.window.width - 175) / 320);
      //alert(this.koliko_tankova_2);
    },
    getAllSifarnik() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/menu/wine", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // console.log(response.data);

          this.items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/menu/wine",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1111);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    this.getAllSifarnik();
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/parts/_tanksRoom.scss";

.WineBox {
  position: relative;
  width: 163px;
  height: 243px;
  border: 1px solid #e2e2e2;
  margin: 0px 10px 0px;
  transition: border 0.2s ease-in-out;

  &__Img {
    height: 206px;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      max-height: 200px;
    }
  }
  &__Title {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    letter-spacing: 0;
    text-align: center;
    color: #333333;
    margin-top: 10px;
    // text-transform: uppercase;
    font-family: NunitoSans, sans-serif;
  }
}

.WineTypes {
  margin-top: 20px;
  margin-bottom: 30px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      width: 100%;
      display: flex;
      font-weight: 400;
      margin-bottom: 10px;
      // text-transform: uppercase;
      justify-content: space-between;
      i {
        font-size: 8px;
        vertical-align: top;
        margin-top: 6px;
      }
      .moreInfo {
        font-family: "NunitoSans", sans-serif;
        font-weight: 700;
        font-size: 14px;
        color: rgb(1, 131, 137);
        text-decoration: none;
      }
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    &__Wine {
      display: flex;
      margin-bottom: 30px;
      margin-right: 20px;
      .WineBox {
        margin-right: 15px;
      }
      .WineYears {
        width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: 1px solid #e2e2e2;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          color: rgb(1, 131, 137)!important;
          letter-spacing: 0;
          text-align: center;
        }
      }
    }
  }
}

.Actions__Content {
  padding: 20px 33px 20px;
}

.columnRightVineType {
  color: #018389;
  text-decoration: none;
}
</style>
